import { render, staticRenderFns } from "./CreateLayout.vue?vue&type=template&id=7349e649&scoped=true"
import script from "./CreateLayout.vue?vue&type=script&lang=js"
export * from "./CreateLayout.vue?vue&type=script&lang=js"
import style0 from "./CreateLayout.vue?vue&type=style&index=0&id=7349e649&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349e649",
  null
  
)

export default component.exports